import { render, staticRenderFns } from "./editmaterial.vue?vue&type=template&id=410686b4&scoped=true"
import script from "./editmaterial.vue?vue&type=script&lang=ts"
export * from "./editmaterial.vue?vue&type=script&lang=ts"
import style0 from "./editmaterial.vue?vue&type=style&index=0&id=410686b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410686b4",
  null
  
)

export default component.exports